import { render } from "./TheConsumerDetails.vue?vue&type=template&id=7ef24706"
import script from "./TheConsumerDetails.vue?vue&type=script&lang=js"
export * from "./TheConsumerDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__